import * as React from "react";
import { TenantSwitcherContext } from "./tenant-switcher-context";

export function useTenantSwitcher() {
	const context = React.useContext(TenantSwitcherContext);
	if (!context) {
		throw new Error("useTenantSwitcher must be used within TenantSwitcherProvider");
	}
	return context;
}
